export default class AbstractStorage {

  static $inject = [
    '$window',
  ];

  constructor($window) {
    this.$window = $window;

    if (!this.isAvailable()) {
      return { available: false };
    }

    this.available = true;
    this.storage = window[this.name()];
  }

  isAvailable() {
    try {
      const storage = window[this.name()];
      const x = '__test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  }

  reset() {
    return this.storage.clear();
  }

  set(key, value) {
    if (_.isObject(value) || _.isArray(value)) {
      value = JSON.stringify(value);
    }

    this.storage.setItem(key, value);
  }

  get(key, otherwise = null) {
    if (!this.has(key)) {
      return otherwise;
    }

    const value = this.storage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  has(key) {
    return (this.storage[key] != null);
  }

  remove(key) {
    if (this.has(key)) {
      return this.storage.removeItem(key);
    }
    return false;
  }

  all() {
    const items = this.storage;
    return _.mapValues(items, (value) => {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    });
  }

  name() {
    return new Error('name method should be overridden with storage name.');
  }
}



// WEBPACK FOOTER //
// ./main/providers/abstract-storage.js